import {
  FormViewConfig,
  FormViewServiceProvider,
  vsProviderName as FormViewServiceProviderName,
} from "../../../records/forms/formView";
import { RecordDataSource } from "../../../records/grids";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  vsServiceName as ColumnDefinitionSetServiceName,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import fieldHelpers from "../../../ui-formly/fieldHelpers";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../records/forms/formly/fieldConfigurationHelpers";
import { vsLookupManagementServiceName as machineLookupManagementServiceName } from "../../shared/lookups";
import { LookupManagementService } from "../../../records/lookup/lookupManagement";
import { machineConfigurationTypeObjectName } from "../../shared/names";
export { machineConfigurationTypeObjectName as vsObjectName } from "../../shared/names";
import * as lookupNames from "../configs/lookup";
//export const vsObjectName = "machineConfigurationType";

machineConfigurationTypeConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
  FormViewServiceProviderName,
];
export function machineConfigurationTypeConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider,
  formViewServiceProvider: FormViewServiceProvider
) {
  configureGrid(
    recordGridViewServiceProvider,
    columnDefinitionSetServiceProvider
  );

  configureForm(formViewServiceProvider);
}

function configureGrid(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    machineConfigurationTypeObjectName,
    [
      ColumnDefinitionServiceName,
      ColumnDefinitionSetServiceName,
      (columnDefinitionService: ColumnDefinitionService) => [
        
        columnDefinitionService.getStringColDef({
          field: "MachineConfigurationTypeName",
          header: "Configuration Type",
        }),
        columnDefinitionService.getStringColDef({
          field: "MachineGameFamilyName",
          header: "Game Family",
        }),
        columnDefinitionService.getStringColDef({
          field: "MachineGameNameName",
          header: "Game Name",
        }),
        columnDefinitionService.getStringColDef({
          field: "Description",
        }),
        columnDefinitionService.getStringColDef({
          field: "MachineGameTypeName",
          header: "Game Type",
        }),
        columnDefinitionService.getStringColDef({
          field: "MachineDisplayTypeName",
          header: "Machine Display Type",
        }),
        columnDefinitionService.getBooleanColDef({
          field: "MultiGame",
          header: "Multi Game",
        }),
        columnDefinitionService.getBooleanColDef({
          field: "MultiDenom",
          header: "Multi Denom",
        }),
        columnDefinitionService.getBooleanColDef({
          field: "MultiPar",
          header: "Multi PAR",
        }),
        columnDefinitionService.getStringColDef({
          field: "MachineProgressiveTypeName",
          header: "Machine Progressive Type",
        }),
        columnDefinitionService.getNumberColDef({
          field: "SystemPar",
          header: "System PAR",
        }),
        columnDefinitionService.getNumberColDef({
          field: "MultiPar",
          header: "Multi PAR",
        }),
        columnDefinitionService.getNumberColDef({
          field: "FirstCoinParWIncrement",
          header: "First Coin PAR w Increment",
        }),
        columnDefinitionService.getNumberColDef({
          field: "MaxCoinParWIncrement",
          header: "Max Coin PAR w Increment",
        }),

        columnDefinitionService.getBooleanColDef({
          field: "InclusiveProgressive",
          header: "Inclusive Progressive",
        }),
        columnDefinitionService.getNumberColDef({
          field: "CoinsPerPoint",
          header: "Coins Per Point",
        }),
        columnDefinitionService.getNumberColDef({
          field: "PointsAwarded",
          header: "Points Awarded",
        }),
        columnDefinitionService.getNumberColDef({
          field: "TopAward",
          header: "TopAward",
        }),
        columnDefinitionService.getStringColDef({
          field: "CPULockType",
          header: "CPU Lock Type",
        }),
        columnDefinitionService.getBooleanColDef({
          field: "CameraCoverage",
          header: "Camera Coverage",
        }),
      ],
    ]
  );

  recordGridViewServiceProvider.addGridConfiguration(
    machineConfigurationTypeObjectName,
    [
      ServerUtilityName,
      GridSettingsServiceName,
      (
        serverUtility: ServerUtility,
        gridSettingsService: GridSettingsService
      ) => {
        return {
          columnDefinitionSet: machineConfigurationTypeObjectName,
          defaultSort: "MachineConfigurationTypeName",
          gridDataSource: new RecordDataSource(
            serverUtility,
            "/api/machines/MachineConfigurationType"
          ),
          nameSingular: "Configuration Type",
          gridSettings: gridSettingsService.getGridSettings(
            Symbol(machineConfigurationTypeObjectName)
          ),
          showAddButton: true,
          showAddButtonPermission: ["machineEdit"],
        };
      },
    ]
  );
}
function configureForm(formViewServiceProvider: FormViewServiceProvider) {
  formViewServiceProvider.addFormViewConfig(
    machineConfigurationTypeObjectName,
    [
      FieldConfigurationHelperServiceName,
      machineLookupManagementServiceName,
      (
        fieldConfigurationHelperService: FieldConfigurationHelperService,
        machineLookupManagementService: LookupManagementService
      ): FormViewConfig => {
        return {
          fields: [
            ...fieldHelpers.columnLayout(
              [
                fieldHelpers.simpleStringField({
                  key: "Name",
                  label: "IGT Type ID",
                }),
                fieldConfigurationHelperService.lookupField(
                  machineLookupManagementService,
                  {
                    objectName: lookupNames.gameFamilyName,
                    key: "MachineGameFamilyId",
                    label: "Game Family",
                  }
                ),
                fieldConfigurationHelperService.lookupField(
                  machineLookupManagementService,
                  {
                    objectName: lookupNames.gameNameName,
                    key: "MachineGameNameId",
                    label: "Game Name",
                  }
                ),
                fieldHelpers.simpleStringField({
                  key: "Description",
                  label: "Description",
                }),
                fieldConfigurationHelperService.lookupField(
                  machineLookupManagementService,
                  {
                    objectName: lookupNames.gameTypeName,
                    key: "MachineGameTypeId",
                    label: "Game Type",
                  }
                ),
                fieldConfigurationHelperService.lookupField(
                  machineLookupManagementService,
                  {
                    objectName: lookupNames.displayTypeName,
                    key: "MachineDisplayTypeId",
                    label: "Display Type",
                  }
                ),
                fieldConfigurationHelperService.lookupField(
                  machineLookupManagementService,
                  {
                    objectName: lookupNames.progressiveTypeName,
                    key: "MachineProgressiveTypeId",
                    label: "Progressive Type",
                  }
                ),
                fieldHelpers.simpleBoolField({
                  key: "InclusiveProgressive",
                  label: "Inclusive Progressive",
                  defaultValue: false,
                }),
                fieldHelpers.simpleNumberField({
                  key: "CoinsPerPoint",
                  label: "Coins Per Point",
                }),
                fieldHelpers.simpleNumberField({
                  key: "PointsAwarded",
                  label: "Points Awarded",
                }),
                fieldHelpers.simpleNumberField({
                  key: "TopAward",
                  label: "Top Award",
                  min: 0,
                }),
                fieldHelpers.simpleBoolField({
                  key: "CameraCoverage",
                  label: "Camera Coverage",
                  defaultValue: false,
                }),
                /* TODO - fill in client specific game configuration type fields */
              ],
              4
            ),
            fieldConfigurationHelperService.editRepeaterField({
              key: "GameConfigs",
              allowAdd: true,
              allowAddBottom: true,
              displayNameSingular: "Games",
              repeaterFields: [
                ...fieldHelpers.columnLayout(
                  [
                    fieldHelpers.simpleReadonlyField({
                      key: "MachineThemeId",
                      required: true,
                      label: "Theme",
                      formatters: [
                        (_, scope) => {
                          return scope.model?.MachineTheme?.Name;
                        },
                      ],
                    }),
                    fieldHelpers.simpleReadonlyField({
                      key: "MachineDenominationId",
                      required: true,
                      label: "Denomination",
                      formatters: [
                        (_, scope) => scope.model?.MachineDenomination?.Name,
                      ],
                    }),
                    fieldHelpers.simpleReadonlyField({
                      key: "Paylines",
                      label: "Paylines",
                    }),
                    fieldHelpers.simpleReadonlyField({
                      key: "RTPWIncrement",
                      label: "RTP w/ Increment",
                    }),
                    fieldHelpers.simpleReadonlyField({
                      key: "FirstRTPWIncrement",
                      label: "First RTP w/ Increment",
                    }),
                    fieldHelpers.simpleReadonlyField({
                      key: "MaxRTPWIncrement",
                      label: "Max RTP w/ Increment",
                    }),
                    fieldHelpers.simpleReadonlyField({
                      key: "Paytable",
                      label: "Paytable",
                    }),
                    fieldHelpers.simpleReadonlyField({
                      key: "MaxBet",
                      label: "Max Bet",
                    }),
                    fieldHelpers.simpleReadonlyField({
                      key: "ParSheetPar",
                      label: "PAR Sheet PAR",
                    }),
                    fieldHelpers.simpleReadonlyField({
                      key: "ProgressiveIncrement",
                      label: "Progressive Increment",
                    }),
                    fieldHelpers.simpleReadonlyField({
                      key: "Par",
                      label: "System PAR",
                    }),
                    fieldHelpers.simpleReadonlyField({
                      key: "TopAward",
                      label: "Top Award",
                    }),
                    fieldHelpers.simpleReadonlyField({
                      key: "Variation",
                      label: "Variation",
                    }),
                    fieldHelpers.simpleReadonlyField({
                      key: "ExcludeFromCalculations",
                      label: "Exclude from caclulations?",
                      formatters: [
                        (_, scope) =>
                          scope.model?.ExcludeFromCalculations ? "Yes" : "No",
                      ],
                    }),
                    {
                      key: "copyDelete",
                      type: "recordRepeaterCopyDelete",
                      className: "col-xs-9",
                      templateOptions: {
                        label: " ",
                        allowMove: true,
                        allowEdit: true,
                      },
                    },
                  ],
                  4
                ),
              ],
              editFields: [
                ...fieldHelpers.columnLayout(
                  [
                    fieldConfigurationHelperService.lookupField(
                      machineLookupManagementService,
                      {
                        objectName: lookupNames.themeName,
                        key: "MachineThemeId",
                        required: true,
                        label: "Theme",
                      }
                    ),
                    fieldConfigurationHelperService.lookupField(
                      machineLookupManagementService,
                      {
                        objectName: lookupNames.denominationName,
                        key: "MachineDenominationId",
                        required: true,
                        label: "Denomination",
                      }
                    ),
                    fieldHelpers.simpleStringField({
                      key: "Paylines",
                      label: "Paylines",
                    }),
                    fieldHelpers.simplePercentageField({
                      key: "RTPWIncrement",
                      label: "RTP w/ Increment",
                    }),
                    fieldHelpers.simplePercentageField({
                      key: "FirstRTPWIncrement",
                      label: "First RTP w/ Increment",
                    }),
                    fieldHelpers.simplePercentageField({
                      key: "MaxRTPWIncrement",
                      label: "Max RTP w/ Increment",
                    }),
                    fieldHelpers.simpleStringField({
                      key: "Paytable",
                      label: "Paytable",
                    }),
                    fieldHelpers.simpleNumberField({
                      key: "MaxBet",
                      label: "Max Bet",
                    }),
                    fieldHelpers.simplePercentageField({
                      key: "ParSheetPar",
                      label: "PAR Sheet PAR",
                    }),
                    fieldHelpers.simplePercentageField({
                      key: "ProgressiveIncrement",
                      label: "Progressive Increment",
                    }),
                    fieldHelpers.simplePercentageField({
                      key: "Par",
                      label: "System PAR",
                    }),
                    fieldHelpers.simpleNumberField({
                      key: "TopAward",
                      label: "Top Award",
                    }),
                    fieldHelpers.simpleStringField({
                      key: "Variation",
                      label: "Variation",
                    }),
                    fieldHelpers.simpleBoolField({
                      key: "ExcludeFromCalculations",
                      label: "Exclude from caclulations?",
                    }),
                    {
                      key: "copyDelete",
                      type: "recordRepeaterCopyDelete",
                      className: "col-xs-9",
                      templateOptions: {
                        label: " ",
                        allowMove: true,
                        allowEditComplete: true,
                      },
                    },
                  ],
                  4
                ),
              ],
              showHeader: true,
              label: "Games",
            }),
            fieldConfigurationHelperService.repeaterField({
              key: "Hyperlinks",
              allowAdd: true,
              allowAddBottom: true,
              displayNameSingular: "Hyperlink",
              displayNamePlural: "Hyperlinks",
              repeaterFields: [
                ...fieldHelpers.columnLayout(
                  [
                    fieldHelpers.simpleStringField({
                      key: "DisplayText",
                      label: "Display Text",
                      required: true,
                    }),
                    fieldHelpers.simpleStringField({
                      key: "Url",
                      required: true,
                    }),
                    {
                      key: "copyDelete",
                      type: "recordRepeaterCopyDelete",
                      className: "col-xs-6",
                      templateOptions: {
                        label: " ",
                        allowMove: true,
                      },
                    },
                  ],
                  4
                ),
              ],
              showHeader: true,
              label: "Hyperlinks",
            }),
            fieldHelpers.headerField({
              headerText: "Configuration Documents",
              key: "FileHeader",
            }),
            {
              key: "Files",
              type: "recordFileUpload",
              templateOptions: {
                label: "Configuration Documents",
                allowMultiple: true,
                hideLabel: true,
                group: "Configuration",
              },
            },
            fieldHelpers.headerField({
              headerText: "Annual Hold Adjustments",
              key: "AnnualHoldHeader",
            }),
            {
              key: "Files",
              type: "recordFileUpload",
              templateOptions: {
                label: "Annual Hold Adjustments",
                allowMultiple: true,
                hideLabel: true,
                group: "AnnualHoldAdjustment",
              },
            },
            fieldHelpers.headerField({
              headerText: "PAR Sheets",
              key: "AnnualHoldHeader",
            }),
            {
              key: "Files",
              type: "recordFileUpload",
              templateOptions: {
                label: "PAR Sheets",
                allowMultiple: true,
                hideLabel: true,
                group: "ParSheet",
              },
            },
            fieldHelpers.headerField({
              headerText: "Configuration Notes",
              key: "Notes",
            }),
            fieldHelpers.textAreaField({
              key: "Notes",
              label: " ",
              rows: 5,
            }),
          ],
          name: machineConfigurationTypeObjectName,
          title: () => "Configuration Type",
          showButtonsAtTop: true,
        };
      },
    ]
  );
}
